import React, { Fragment } from 'react'
import {
  Typography,
  SpacerVertical,
  Stepper,
} from '@klarna/bubble-ui'
import { Node } from '../types'
import getValueFromNodes from '../utilities/getValueFromNode'
import styles from './styles.css'
import LegalText from '../components/LegalText/LegalText'

type TimelineBasedProps = {
  nodes: Node[]
  theme: string
};

export default function TimelineBased(props: TimelineBasedProps) {
  const { nodes } = props

  const timelineEntries = [
    getValueFromNodes(nodes, 'TIMELINE_STEP_1'),
    getValueFromNodes(nodes, 'TIMELINE_STEP_2'),
    getValueFromNodes(nodes, 'TIMELINE_STEP_3'),
    getValueFromNodes(nodes, 'TIMELINE_STEP_4'),
  ]
    .filter(Boolean)
    .map(v => ({
      title: v,
      description: '',
    }))

  return (
    <Fragment>
      <style>{styles}</style>
      <Typography id="learn-more-title" textToken='text-style/headings/titles/bold/tertiary'>
        {getValueFromNodes(nodes, 'TITLE')}
      </Typography>
      <SpacerVertical spaceToken="space.50" />
      {getValueFromNodes(nodes, 'SUB_TITLE') ? (
        <Typography textToken='text-style/text/paragraphs/body/regular'>
          {getValueFromNodes(nodes, 'SUB_TITLE')}
        </Typography>
      ) : null}
      <SpacerVertical spaceToken="space.200" />
      <div className="timeline">
        <Stepper>
          {timelineEntries.map((entry, index) => (
            <Stepper.Item key={index} title={entry.title} description={entry.description} />
          ))}
        </Stepper>
      </div>
      <SpacerVertical spaceToken="space.200" />
      <LegalText
        legalText={getValueFromNodes(nodes, 'LEGAL_TEXT')}
      />
    </Fragment>
  )
}
